// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__1Waq4","legacyBtn":"MutateMid_legacyBtn__2GjPT"};